import uploadcare from 'uploadcare-widget'

const KB = 1024
export const MB = 1024 * KB

export const byteToMegabyte = (size) => {
  return size / MB
}

export const setErrorMessages = (locale = 'en', errorMessages = null) => {
  // For reference: https://github.com/uploadcare/uploadcare-widget/blob/master/src/locales/en.js
  const localeTranslations = {
    dialog: {
      tabs: {
        preview: {
          error: {
            ...errorMessages,
          },
        },
      },
    },
  }

  uploadcare.plugin((uc) => {
    uc.locale.rebuild({
      locale,
      localeTranslations,
    })
  })
}

export const maxSize = (size) => {
  return (fileInfo) => {
    if (fileInfo.size > size) {
      throw new Error('size')
    }
  }
}
